(function () {
  var root = document.querySelector('[data-le-blog-filter]');
  var nav = document.querySelector('.blog-filter-nav__tabs');
  if (!root || !nav) return;

  var cards = root.querySelectorAll('.post-card[data-le-tags], .post-card[data-le-tag]');
  var hero = root.querySelector('[data-le-hero-post]');
  var emptyEl = root.querySelector('[data-le-empty]');
  var heroArticleId = hero ? hero.getAttribute('data-le-hero-article-id') : '';

  function tagFromUrl() {
    return new URLSearchParams(window.location.search).get('tag') || '';
  }

  function cardTagList(card) {
    var raw = card.getAttribute('data-le-tags') || card.getAttribute('data-le-tag') || '';
    return raw.split(',').map(function (t) { return t.trim(); }).filter(Boolean);
  }

  function cardMatchesTag(card, tagHandle) {
    if (!tagHandle) return true;
    return cardTagList(card).indexOf(tagHandle) !== -1;
  }

  function isHeroDuplicate(card, tagHandle) {
    if (!hero || !heroArticleId) return false;
    if (card.getAttribute('data-le-article-id') !== heroArticleId) return false;
    return !tagHandle || tagHandle === 'featured';
  }

  function setActiveTab(tagHandle) {
    nav.querySelectorAll('.blog-filter-tab').forEach(function (tab) {
      tab.classList.remove('active');
      var tabTag = tab.getAttribute('data-tag-handle') || '';
      if (!tagHandle && tab.classList.contains('blog-filter-tab--all')) {
        tab.classList.add('active');
      } else if (tagHandle && tabTag === tagHandle) {
        tab.classList.add('active');
      }
    });
  }

  function applyFilter(tagHandle) {
    var visible = 0;

    cards.forEach(function (card) {
      var show = cardMatchesTag(card, tagHandle) && !isHeroDuplicate(card, tagHandle);
      card.style.display = show ? '' : 'none';
      if (show) visible += 1;
    });

    if (hero) {
      var showHero = !tagHandle || tagHandle === 'featured';
      hero.style.display = showHero ? '' : 'none';
    }

    var heroVisible = hero && hero.style.display !== 'none';

    if (emptyEl) {
      if (tagHandle && visible === 0 && !heroVisible) {
        var tab = nav.querySelector('[data-tag-handle="' + tagHandle + '"]');
        var label = tab ? tab.textContent.trim() : tagHandle;
        emptyEl.textContent = 'No posts in ' + label + ' yet — check back soon.';
        emptyEl.hidden = false;
      } else {
        emptyEl.hidden = true;
      }
    }

    setActiveTab(tagHandle);
  }

  nav.addEventListener('click', function (e) {
    var tab = e.target.closest('.blog-filter-tab');
    if (!tab) return;
    e.preventDefault();
    var tagHandle = tab.getAttribute('data-tag-handle') || '';
    var href = tab.getAttribute('href');
    if (href) {
      history.pushState(null, '', href);
    }
    applyFilter(tagHandle);
  });

  window.addEventListener('popstate', function () {
    applyFilter(tagFromUrl());
  });

  applyFilter(tagFromUrl());
})();
